// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Xnl","colBig":"styles_colBig__FOQ8w","colSmall":"styles_colSmall__1Qi4j","shopifyNameWrapper":"styles_shopifyNameWrapper__Og5mS"};